import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './ThankYouPage.css';

const ThankYouPage = () => {
  const [order, setOrder] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLastOrder = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('/api/user/me', {
          headers: { Authorization: `Bearer ${token}` },
        });
        const orders = response.data.orders;
        if (orders.length > 0) {
          setOrder(orders[orders.length - 1]);
        }
      } catch (err) {
        console.error('Error fetching last order:', err);
      }
    };

    fetchLastOrder();
  }, []);

  return (
    <div className="thank-you-container">
      <div className="thank-you-content">
        <div className="icon-container">
          <span className="check-icon">✔</span>
        </div>
        <h1>Thank You for Your Order!</h1>
        <p>Your order has been successfully placed and is being processed.</p>
        
        {order && (
          <div className="order-summary">
            <h2>Order Details</h2>
            <table>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Quantity</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {order.items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.productName}</td>
                    <td>{item.quantity}</td>
                    <td>₹{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="button-group">
          <button onClick={() => navigate('/shop')} className="primary-button">Continue Shopping</button>
          <button onClick={() => navigate('/account')} className="secondary-button">View Your Account</button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
